import type { ISnackbarData } from "~/types/components/snackbar.type";

export const useSnackbar = () => {
  const showSnackbar = useState<boolean>("showSnackbar", () => false);
  const snackContent = useState<ISnackbarData>("snackContent", () => {
    return {} as ISnackbarData;
  });

  const timeOut = ref<number | null>(null);

  const closeSnackbar = () => {
    showSnackbar.value = false;
    snackContent.value = {} as ISnackbarData;
    clearNuxtState("snackContent");

    if (timeOut.value) {
      clearTimeout(timeOut.value);
      timeOut.value = null;
    }
  };

  const openSnackbar = (content: ISnackbarData) => {
    showSnackbar.value = true;
    snackContent.value = content;

    if (timeOut.value) {
      clearTimeout(timeOut.value);
    }

    timeOut.value = setTimeout(() => {
      closeSnackbar();
    }, 5000) as unknown as number;
  };

  return { showSnackbar, snackContent, openSnackbar, closeSnackbar };
};
